import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { catchError, mapTo, tap } from "rxjs/operators";
import { environment } from "src/environments/environment";
import {
  RespCatalogInfo,
  RespCountriesObservation,
  RespDelete,
  RespGpsLocationsObservation,
  RespRegionsObservation,
  RespSearchObservation,
  RespStats,
  RespSync,
  RespWebService,
} from "../model/observation.model";
import { map } from "leaflet";

@Injectable({
  providedIn: "root",
})
export class ObservationService {
  baseUrl = environment.baseUrl;
  constructor(private httpClient: HttpClient) { }
  clearFilters() { }

  getSearch(_var: {
    page: number | null;
    page_size: number | null;
    variety_name: string | null;
    country: string | null;
    region: string | null;
    farmer_name: string | null;
    province: string | null;
    district: string | null;
    locality: string | null;
    observation_date: string | null;
    observation_date_start: string | null;
    observation_date_end: string | null;
    user_id: number | null;
    is_public: boolean | null;
    varietal_group: string | null;
    farmer_id: number | null;
    is_original: boolean | null;
    months: number | null;
    sort_by: string | null;
  }): Observable<RespSearchObservation> {
    const _route = "variety-observation/basic-filter?";
    const _page = "page=" + (_var.page ? _var.page + 1 : 1);
    const _page_size = "&page_size=" + (_var.page_size ? _var.page_size : 20);
    const _variety_name = _var.variety_name ? "&variety_name=" + _var.variety_name : "";
    const _country = _var.country ? "&country=" + _var.country : "";
    const _region = _var.region ? "&region=" + _var.region : "";
    const _farmer_name = _var.farmer_name ? "&farmer_name=" + _var.farmer_name : "";
    const _province = _var.province ? "&province=" + _var.province : "";
    const _district = _var.district ? "&district=" + _var.district : "";
    const _locality = _var.locality ? "&locality=" + _var.locality : "";
    const _observation_date = _var.observation_date ? "&observation_date=" + _var.observation_date : "";
    const _observation_date_start = _var.observation_date_start ? "&observation_date_start=" + _var.observation_date_start : "";
    const _observation_date_end = _var.observation_date_end ? "&observation_date_end=" + _var.observation_date_end : "";
    const _user_id = _var.user_id ? "&user_id=" + _var.user_id : "";
    const _is_public = _var.is_public != null ? '&is_public=' + _var.is_public : "";
    const _varietal_group = _var.varietal_group ? "&varietal_group=" + _var.varietal_group : "";
    const _farmer_id = _var.farmer_id ? "&farmer_id=" + _var.farmer_id : "";
    const _is_original = _var.is_original != null ? '&is_original=' + _var.is_original : "";
    const _months = _var.months ? "&months=" + _var.months : "";
    const _sort_by = _var.sort_by ? "&sort_by=" + _var.sort_by : "";

    const _url = `${this.baseUrl}${_route}${_page}${_page_size}${_variety_name}${_country}${_region}${_farmer_name}${_observation_date}${_observation_date_start}${_observation_date_end}${_user_id}${_is_public}${_varietal_group}${_farmer_id}${_is_original}${_months}${_sort_by}`;
    console.log(_url);
    return this.httpClient.get<RespSearchObservation>(_url);
  }

  getCountries(): Observable<RespCountriesObservation> {
    const _route = "variety-observation/countries";
    return this.httpClient.get<RespCountriesObservation>(
      `${this.baseUrl}${_route}`
    );
  }

  getRegions(country: string): Observable<RespRegionsObservation> {

    const _country = "country=" + country;
    const response = new RespSync();
    const _route = "variety-observation/regions?";
    const _url = `${this.baseUrl}${_route}${_country}`;
    return this.httpClient.get<any>(_url);
  }

  getFarmers(): Observable<any> {
    const _route = "variety-observation/farmers";
    return this.httpClient.get<any>(
      `${this.baseUrl}${_route}`
    );
  }

  getFarmerNames(
    _var: {
      farmer_name: string | null,
      is_public: boolean | null,
    }

  ) {
    const _route = "variety-observation/farmer-names?";
    const _farmer_name = "farmer_name=" + _var.farmer_name;
    const _is_public = _var.is_public != null ? '&is_public=' + _var.is_public : "";
    const _url = `${this.baseUrl}${_route}${_farmer_name}${_is_public}`;
    return this.httpClient.get<any>(`${_url}`);
  }


  getGpsLocations(req: { is_public: boolean | null }): Observable<RespGpsLocationsObservation> {
    const _route = "variety-observation/gps-locations?";
    const _is_public = req.is_public != null ? "is_public=" + req.is_public : "";
    const _url = `${this.baseUrl}${_route}${_is_public}`;
    return this.httpClient.get<RespGpsLocationsObservation>(
      `${_url}`
    );
  }

  getCatalogInfo(id: string | number): Observable<RespCatalogInfo> {
    return this.httpClient.get<RespCatalogInfo>(
      `${this.baseUrl}variety-observation/${id}/catalog-info`
    );
  }

  getCounts(): Observable<any> {
    const _route = "variety-observation/counts";
    return this.httpClient.get<any>(`${this.baseUrl}${_route}`);
  }

  // patchIsPublic(
  //   req: {
  //     variety_observation_id: number,
  //     is_public: boolean | null
  //   }

  // ): Observable<{}> | any {

  //   if (req.is_public) {
  //     const _route = "variety-observation/";
  //     const _url = `${this.baseUrl}${_route}${req.variety_observation_id}`;
  //     const _is_public = "is_public=" + req.is_public.toString();
  //     return this.httpClient.patch(_url, { is_public: _is_public });
  //   }

  // }

  patchIsPublic(
    _variety_observation_id: number,
    _is_public: boolean | null
  ): Observable<{}> {
    const _route = "variety-observation/";
    const _url = `${this.baseUrl}${_route}${_variety_observation_id}`;
    return this.httpClient.patch(_url, { is_public: _is_public });
  }


  getVarScoutObservation(
    _variety_observation_id: number | string | null
  ): Observable<{}> {
    const _route = "variety-observation/varscout/";
    const _url = `${this.baseUrl}${_route}${_variety_observation_id}`;
    return this.httpClient.get<any>(_url);
  }

  putVarScoutObservation(
    _vs_id: string | null,
    _variety_observation_body: any
  ): Observable<any> {
    const response = new RespWebService();
    const _route = "variety-observation/varscout/";
    const _url = `${this.baseUrl}${_route}${_vs_id}`;
    return this.httpClient.put(_url, _variety_observation_body).pipe(
      tap(
        (_response: any) => {
          response.success = true;
          response.data = _response.data;
        }
      ),
      mapTo(response),
      catchError(error => {
        response.success = false;
        response.data = 'error';
        return of(response);
      }));
  }

  createVarScoutObservation(
    _variety_observation_body: any
  ): Observable<any> {

    const response = new RespWebService();
    const _route = "variety-observation/";
    const _url = `${this.baseUrl}${_route}`;

    return this.httpClient.post(_url, _variety_observation_body).pipe(
      tap(
        (_response: any) => {
          response.success = true;
          response.data = _response.data;
        }
      ),
      mapTo(response),
      catchError(error => {
        response.success = false;
        response.data = 'error';
        return of(response);
      }));

  }

  getActivityObservation(
    _variety_observation_id: number | string | null
  ): Observable<{}> {
    const _route = "variety-observation-activity/?variety_observation_id=";
    const _url = `${this.baseUrl}${_route}${_variety_observation_id}`;
    return this.httpClient.get<any>(_url);
  }

  getStats(): Observable<{}> {
    const response = new RespStats();
    const _route = "variety-observation/stats";
    const _url = `${this.baseUrl}${_route}`;
    return this.httpClient.get<any>(_url).pipe(
      tap(
        (_response: any) => {
          response.success = _response.success;
          response.data = _response.data;
        }
      ),
      mapTo(response),
      catchError(error => {
        response.success = false;
        response.data = 'error';
        return of(response);
      }));
  }

  getSync(_var: { start_date: string }): Observable<{}> {
    const response = new RespSync();
    const _route = "sync";
    const _start_date = _var.start_date ? "?start_date=" + _var.start_date : "";
    const _url = `${this.baseUrl}${_route}${_start_date}`;
    return this.httpClient.get<any>(_url).pipe(
      tap(
        (_response: any) => {
          response.success = _response.success;
          response.data = _response.data;
          response.message = _response.message
        }
      ),
      mapTo(response),
      catchError(error => {
        response.success = false;
        response.data = 'error';
        return of(response);
      }));
  }

  deleteObservation(id: string | number): Observable<any> {
    const response = new RespDelete();
    const _route = "variety-observation/";
    const _id = id ? id : "";
    const _url = `${this.baseUrl}${_route}${_id}`;
    return this.httpClient.delete<any>(`${_url}`).pipe(
      tap(
        (_response: any) => {
          response.success = _response.success;
          response.data = _response.data;
          response.message = _response.message
        }
      ),
      mapTo(response),
      catchError(error => {
        response.success = false;
        response.data = 'error';
        return of(response);
      }));
  }


  getVarietyNames(req: {
    variety_name: string,
    is_original: boolean | null,
    page: number | null,
    page_size: number | null,
    is_public: boolean | null
  }) {
    const _route = "variety-observation/variety-names?";

    const _page = "&page=" + (req.page ? req.page : 1);
    const _page_size = "&page_size=" + (req.page_size ? req.page_size : 100);

    const _variety_name = "&variety_name=" + req.variety_name;
    const _is_original = req.is_original != null ? "&is_original=" + req.is_original : "";
    const _is_public = req.is_public != null ? "&is_public=" + req.is_public : "";

    return this.httpClient.get<any>(`${this.baseUrl}${_route}${_page}${_page_size}${_variety_name}${_is_original}${_is_public}`);
  }

}
